import { render, staticRenderFns } from "./ProspectClient.vue?vue&type=template&id=143d7689"
import script from "./ProspectClient.vue?vue&type=script&lang=ts"
export * from "./ProspectClient.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports